export default {
    "name": "GetZois",
    "kind": "HoudiniQuery",
    "hash": "c88bd1ebdde7b4195585f333b9073875bf52693a7c233d9d8080ee413af02b77",

    "raw": `query GetZois($input: GetZoisInput!) {
  getZois(input: $input) {
    zoiList {
      zoiId
      name
      center {
        lng
        lat
      }
      radius
      polygon {
        type
        coordinates
      }
      images {
        ...ImageFragment
      }
      zoiImages {
        ...ImageFragment
      }
      containsEvStation
      description
    }
  }
}

fragment ImageFragment on Image {
  copyright
  w160
  w320
  w640
  w960
  w1280
  w1920
  __typename
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getZois": {
                "type": "GetZoisResult",
                "keyRaw": "getZois(input: $input)",

                "selection": {
                    "fields": {
                        "zoiList": {
                            "type": "Zoi",
                            "keyRaw": "zoiList",

                            "selection": {
                                "fields": {
                                    "zoiId": {
                                        "type": "String",
                                        "keyRaw": "zoiId",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "center": {
                                        "type": "Coordinates",
                                        "keyRaw": "center",

                                        "selection": {
                                            "fields": {
                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                },

                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "radius": {
                                        "type": "Float",
                                        "keyRaw": "radius",
                                        "visible": true
                                    },

                                    "polygon": {
                                        "type": "Polygon",
                                        "keyRaw": "polygon",

                                        "selection": {
                                            "fields": {
                                                "type": {
                                                    "type": "String",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "coordinates": {
                                                    "type": "Float",
                                                    "keyRaw": "coordinates",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "images": {
                                        "type": "Image",
                                        "keyRaw": "images",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "copyright": {
                                                    "type": "String",
                                                    "keyRaw": "copyright",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "w160": {
                                                    "type": "String",
                                                    "keyRaw": "w160",
                                                    "visible": true
                                                },

                                                "w320": {
                                                    "type": "String",
                                                    "keyRaw": "w320",
                                                    "visible": true
                                                },

                                                "w640": {
                                                    "type": "String",
                                                    "keyRaw": "w640",
                                                    "visible": true
                                                },

                                                "w960": {
                                                    "type": "String",
                                                    "keyRaw": "w960",
                                                    "visible": true
                                                },

                                                "w1280": {
                                                    "type": "String",
                                                    "keyRaw": "w1280",
                                                    "visible": true
                                                },

                                                "w1920": {
                                                    "type": "String",
                                                    "keyRaw": "w1920",
                                                    "visible": true
                                                },

                                                "__typename": {
                                                    "type": "String",
                                                    "keyRaw": "__typename",
                                                    "visible": true
                                                }
                                            },

                                            "fragments": {
                                                "ImageFragment": {
                                                    "arguments": {}
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "zoiImages": {
                                        "type": "Image",
                                        "keyRaw": "zoiImages",

                                        "selection": {
                                            "fields": {
                                                "copyright": {
                                                    "type": "String",
                                                    "keyRaw": "copyright",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "w160": {
                                                    "type": "String",
                                                    "keyRaw": "w160",
                                                    "visible": true
                                                },

                                                "w320": {
                                                    "type": "String",
                                                    "keyRaw": "w320",
                                                    "visible": true
                                                },

                                                "w640": {
                                                    "type": "String",
                                                    "keyRaw": "w640",
                                                    "visible": true
                                                },

                                                "w960": {
                                                    "type": "String",
                                                    "keyRaw": "w960",
                                                    "visible": true
                                                },

                                                "w1280": {
                                                    "type": "String",
                                                    "keyRaw": "w1280",
                                                    "visible": true
                                                },

                                                "w1920": {
                                                    "type": "String",
                                                    "keyRaw": "w1920",
                                                    "visible": true
                                                },

                                                "__typename": {
                                                    "type": "String",
                                                    "keyRaw": "__typename",
                                                    "visible": true
                                                }
                                            },

                                            "fragments": {
                                                "ImageFragment": {
                                                    "arguments": {}
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "containsEvStation": {
                                        "type": "Boolean",
                                        "keyRaw": "containsEvStation",
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "GetZoisInput"
        },

        "types": {
            "GetZoisInput": {
                "containsEvOnly": "Boolean",
                "distance": "Int",
                "routeGeometry": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=4d06de5bc6e6c83c6ffedce87854f18dc2d01443ec2c6dec9cd8649bbbb7fb28";